import api from '@pray/shared/utils/api';
import type { CatalogFieldResponse, CatalogFieldType } from './types';
export type DefineFieldInput = {
  name: string; type: CatalogFieldType; position: number; is_required: boolean; is_key: boolean;
};
type Props = { artistId: string; catalogId: string; fields: DefineFieldInput[] };
export async function postDefineFields({ artistId, catalogId, fields }: Props) {
  if (!artistId) throw new Error('Artist ID is required');
  // Backend returns only { fields }, not a full catalog — callers refetch the catalog.
  // Unwrap the envelope one level — see getCatalogs.ts.
  const res = await api.executePostRequest<{ data: { fields: CatalogFieldResponse[] } }>(
    `/web/studio/artists/${artistId}/catalogs/${catalogId}/fields`, { fields });
  return res.data.data;
}
